import React, { ReactElement } from 'react';
import u1Logo from './u1-ubahn-neubauprojekte-wien.svg';
import u2Logo from './u2-ubahn-neubauprojekte-wien.svg';
import u3Logo from './u3-ubahn-neubauprojekte-wien.svg';
import u4Logo from './u4-ubahn-neubauprojekte-wien.svg';
import u5Logo from './u5-ubahn-neubauprojekte-wien.svg';
import u6Logo from './u6-ubahn-neubauprojekte-wien.svg';
import tramLogo from './strassenbahn-neubauprojekte-wien.svg';
import busLogo from './busverbindung-neubauprojekte-wien.svg';
import trainLogo from './schnellbahn-neubauprojekte-wien.svg';

import travelByBusLogo from './wegzeit_bus.svg';
import travelByFootLogo from './wegzeit_fussweg.svg';

import s from '../Portfolio.module.scss';
import { ProjectConnection } from '../../../shared/schema/ProjectConnectionSchema';

interface ConnectionsProps {
  connections: ProjectConnection[];
}

const TransportKeyOrder = {
  'U-Bahn': 1,
  Straßenbahn: 2,
  Autobus: 3,
  'S- und Regionalbahn': 4,
};

export default function Connections(props: ConnectionsProps): ReactElement {
  const { connections } = props;

  let sortedConnections = [...connections];
  sortedConnections.sort(
    (connection1, connection2) =>
      TransportKeyOrder[connection1.transportTypes] -
      TransportKeyOrder[connection2.transportTypes]
  );

  // filter transports already included in collection for same station
  sortedConnections = sortedConnections.filter(
    (connection) =>
      !sortedConnections.some(
        (c) =>
          c.id !== connection.id &&
          c.publicTransportStation === connection.publicTransportStation &&
          c.publicTransport.includes(connection.publicTransport)
      )
  );

  // filter longer connections for same transport type or others if equal
  sortedConnections = sortedConnections.filter((connection) => {
    let foundFasterConnection = null;
    foundFasterConnection = sortedConnections.find(
      (c) =>
        c.id !== connection.id &&
        (c.publicTransport === connection.publicTransport ||
          c.publicTransport.includes(connection.publicTransport)) &&
        c.travelTime < connection.travelTime
    );
    if (!foundFasterConnection) {
      // search for equal long connection
      foundFasterConnection = sortedConnections.find(
        (c) =>
          c.id !== connection.id &&
          (c.publicTransport === connection.publicTransport ||
            c.publicTransport.includes(connection.publicTransport)) &&
          c.travelTime === connection.travelTime &&
          c.id < connection.id // ensure, that not both are removed
      );
    }

    return !foundFasterConnection;
  });

  sortedConnections = sortedConnections.map((connection) => {
    const filteredPublicTransport = connection.publicTransport
      .split(', ')
      .filter((transport) => !transport.startsWith('N'));
    return {
      ...connection,
      publicTransport: filteredPublicTransport.join(', '),
    };
  });

  const renderLogo = (row) => {
    if (row.transportTypes === 'U-Bahn') {
      if (row.publicTransport === 'U1') {
        return <img className={s.transportType} alt="" src={u1Logo} />;
      }
      if (row.publicTransport === 'U2') {
        return <img className={s.transportType} alt="" src={u2Logo} />;
      }
      if (row.publicTransport === 'U3') {
        return <img className={s.transportType} alt="" src={u3Logo} />;
      }
      if (row.publicTransport === 'U4') {
        return <img className={s.transportType} alt="" src={u4Logo} />;
      }
      if (row.publicTransport === 'U5') {
        return <img className={s.transportType} alt="" src={u5Logo} />;
      }
      if (row.publicTransport === 'U6') {
        return <img className={s.transportType} alt="" src={u6Logo} />;
      }
    } else if (row.transportTypes === 'Autobus') {
      return <img className={s.transportType} alt="" src={busLogo} />;
    } else if (row.transportTypes === 'Straßenbahn') {
      return <img className={s.transportType} alt="" src={tramLogo} />;
    } else if (row.transportTypes === 'S- und Regionalbahn') {
      return <img className={s.transportType} alt="" src={trainLogo} />;
    }
    return null;
  };

  const renderConnection = (row) => {
    if (row.connection === 'walking') {
      return <img className={s.connection} alt="" src={travelByFootLogo} />;
    }
    if (row.connection === 'publicTransport') {
      return <img className={s.connection} alt="" src={travelByBusLogo} />;
    }
    return null;
  };

  const renderRows = (rows) =>
    rows.map((r) => (
      <tr className={s.transportRow} key={r.id}>
        <td>{renderLogo(r)}</td>
        <td>
          <b>{r.publicTransport}</b>
        </td>
        <td>{r.publicTransportStation}</td>
        <td>{r.travelTime} Min.</td>
        <td>{renderConnection(r)}</td>
      </tr>
    ));

  return (
    <>
      <div className={s.subTitle}>Öffentliche Anbindung</div>
      <div className={s.tableWrapper}>
        <table>
          <tbody>{renderRows(sortedConnections)}</tbody>
        </table>
      </div>
    </>
  );
}
